import axios from "axios";
import mainConfig from "/config";

export default {
    //
    getDevices() {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        };

        const url = mainConfig.endpoint + 'devices?methods=get_devices';

        return new Promise((resolve, reject) => {
            axios
                .get(url, config)
                .then(resp => {

                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }

                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    getServiceByUid(token, uid) {
      let config = {
      crossdomain: true,
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": token
        }
      };

      let aFormData = new FormData();
      aFormData.append("methods", '__get_service__');
      aFormData.append("uid", uid);

      return new Promise((resolve, reject) => {
        axios
        .post(mainConfig.endpoint + 'services', aFormData, config)
        .then(resp => {
          if (mainConfig.DEBUGMODE) {
            console.warn(resp)
          }
          resolve(resp)
        }).catch(err => {
          if (mainConfig.DEBUGMODE) {
            console.error(err)
          }
        });
      });
    },
    getProceed() {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        };

        const url = mainConfig.endpoint + 'services?methods=get_proceed';

        return new Promise((resolve, reject) => {
            axios
                .get(url, config)
                .then(resp => {

                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }

                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    getServicesOfDevice(device) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        };

        const url = mainConfig.endpoint + 'services?methods=get_services_of_device&device=' + device;

        return new Promise((resolve, reject) => {
            axios
                .get(url, config)
                .then(resp => {

                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }

                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    createOrder(services, proceed, data) {

        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", 'create_order');
        aFormData.append("services", JSON.stringify(services));
        aFormData.append("proceed", proceed);
        aFormData.append("data", JSON.stringify(data));

        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'orders', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    /*
     ********************************************
     **************** Dashbaord *****************
     ********************************************
     */

    // ORDERS
    loadTheOrders(perPage, lastColumns) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        const url = mainConfig.endpoint + 'orders?methods=load_the_orders&perPage=' + perPage + '&lastColumns=' + lastColumns;

        return new Promise((resolve, reject) => {
            axios
                .get(url, config)
                .then(resp => {

                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }

                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    changeOrderState(order) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", 'change_order_state');
        aFormData.append("orderId", order.orderId);
        aFormData.append("state", order.orderState);

        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'orders', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },


    // DEVICES
    loadDashDevives() {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        const url = mainConfig.endpoint + 'devices?methods=load_dash_devives';

        return new Promise((resolve, reject) => {
            axios
                .get(url, config)
                .then(resp => {

                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }

                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    loadInfoDevice(deviceId) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        const url = mainConfig.endpoint + 'devices?methods=load_info_device&deviceId=' + deviceId;

        return new Promise((resolve, reject) => {
            axios
                .get(url, config)
                .then(resp => {

                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }

                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    loadDevices(perPage, lastColumns) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        const url = mainConfig.endpoint + 'devices?methods=load_devices&perPage=' + perPage + '&lastColumns=' + lastColumns;

        return new Promise((resolve, reject) => {
            axios
                .get(url, config)
                .then(resp => {

                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }

                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    uploadDeviceThumbnail(thumbnail) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", 'upload_device_thumbnail');
        aFormData.append("data", JSON.stringify({ thumbnail: thumbnail }));


        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'devices', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    addOrEditDevice(data) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", 'add_new_device');
        aFormData.append("data", JSON.stringify(data));


        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'devices', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    changeDeviceState(device) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", 'change_device_state');
        aFormData.append("deviceId", device.uid);
        aFormData.append("state", device.state);

        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'devices', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    deleteDevice(device) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", 'delete_device');
        aFormData.append("deviceId", device.uid);

        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'devices', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    // SERVICES
    loadTypesServiceAndDevices() {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        const url = mainConfig.endpoint + 'services?methods=load_types_service_and_devices';

        return new Promise((resolve, reject) => {
            axios
                .get(url, config)
                .then(resp => {

                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }

                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    loadServices(perPage, lastColumns) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        const url = mainConfig.endpoint + 'services?methods=load_services&perPage=' + perPage + '&lastColumns=' + lastColumns;

        return new Promise((resolve, reject) => {
            axios
                .get(url, config)
                .then(resp => {

                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }

                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    uploadTypeServiceThumbnail(thumbnail) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", 'upload_type_service_thumbnail');
        aFormData.append("data", JSON.stringify({ thumbnail: thumbnail }));


        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'services', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    addOrEditTypeService(data) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", 'add_or_edit_type_service');
        aFormData.append("data", JSON.stringify(data));


        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'services', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    addOrEditService(data) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", 'add_or_edit_service');
        aFormData.append("data", JSON.stringify(data));


        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'services', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    addPopupThumbnail(data) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                // "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("users_methods", '__update_popup__');
        aFormData.append("uid", data.uid);
        aFormData.append("file", data.file);
        aFormData.append("header", data.header);
        aFormData.append("bodytext", data.bodytext);

        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'account', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    viewPopupThumbnail() {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                // "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("users_methods", '__view_popup__');

        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'account', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    changeServiceState(service) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", 'change_service_state');
        aFormData.append("serviceId", service.uid);
        aFormData.append("state", service.state);

        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'services', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    deleteService(service) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", 'delete_service');
        aFormData.append("serviceId", service.uid);

        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'services', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    deleteTypeService(service) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", 'delete_type_service');
        aFormData.append("serviceId", service.uid);

        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'services', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    // PROCEED
    loadProceed() {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        };

        const url = mainConfig.endpoint + 'services?methods=load_proceed';

        return new Promise((resolve, reject) => {
            axios
                .get(url, config)
                .then(resp => {

                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }

                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    addOrEditProceed(data) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", 'add_or_edit_proceed');
        aFormData.append("data", JSON.stringify(data));


        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'services', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    changeProceeState(proceed) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", 'change_proceed_state');
        aFormData.append("proceedId", proceed.uid);
        aFormData.append("state", proceed.state);

        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'services', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    deleteProceed(proceed) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": JSON.parse(localStorage.account).token
            }
        };

        let aFormData = new FormData();
        aFormData.append("methods", 'delete_proceed');
        aFormData.append("proceedId", proceed.uid);

        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + 'services', aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

}
